import { Col } from "antd";
import AdminModal from "./AdminModal";
import { useState } from "react";
import { useEffect } from "react";


const LogoModal = (props) => {
    const [blog_id, set_blog_id] = useState(null);
    useEffect(() => {
        if (JSON.stringify(props.editcard) != '{}') {
            set_blog_id(props.editcard.blog_id);
            // get_picture();

        } else {
            props.setEditCard({ file_id: [], file_url: [] });
            set_blog_id('');
        }
    }, [props.editcard])
    return (<>
        <AdminModal
            {...props}
            title={(<>
                <Col span={24} style={{ fontWeight: 'bold', fontSize: '20px', position: 'absolute', zIndex: 99, top: 50, left: 25 }} >{props.title}Logo</Col>
            </>)}
            uploads
        >
        </AdminModal>
    </>)
}
export default LogoModal
